// extracted by mini-css-extract-plugin
module.exports = {"scoreSummary":"ScoreSummary_scoreSummary__s27so","composite":"ScoreSummary_composite__2OOFa","sections":"ScoreSummary_sections__nACwW"};